module.exports = __webpack_public_path__ + "static/media/ic_esign_otp_fisdom.f55fd38c.svg";